import React, { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import useAuth from 'hooks/useAuth';

const PostHogUserTracker: React.FC = () => {
  const posthog = usePostHog();
  const { userInfo, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated && userInfo && posthog) {
      // Identify the user with PostHog
      posthog.identify(userInfo.id.toString(), {
        email: userInfo.email,
        username: userInfo.username,
        first_name: userInfo.first_name,
        last_name: userInfo.last_name,
        name: `${userInfo.first_name} ${userInfo.last_name}`,
        title: userInfo.title,
        phone: userInfo.phone,
        company_id: userInfo.primary_company?.id,
        company_name: userInfo.primary_company?.name,
        company_abbr: userInfo.primary_company?.abbr,
        is_email_verified: userInfo.is_email_verified,
        is_phone_verified: userInfo.is_phone_verified,
        is_toolkit_user: userInfo.is_toolkit_user,
        is_enterprise_user: userInfo.is_enterprise_user,
        subscription_status: userInfo.subscription?.status,
        subscription_plan: userInfo.subscription?.plan,
        show_onboarding_steps: userInfo.show_onboarding_steps,
        is_term_condition_accepted: userInfo.is_term_condition_accepted,
        is_license_accepted: userInfo.is_license_accepted,
        companies_count: userInfo.companies?.length || 0,
        integrations: userInfo.integrations,
        permissions: userInfo.permissions,
        controls: userInfo.controls,
      });

      // Set user properties for future events
      posthog.setPersonProperties({
        email: userInfo.email,
        username: userInfo.username,
        first_name: userInfo.first_name,
        last_name: userInfo.last_name,
        name: `${userInfo.first_name} ${userInfo.last_name}`,
        company_name: userInfo.primary_company?.name,
        is_toolkit_user: userInfo.is_toolkit_user,
        is_enterprise_user: userInfo.is_enterprise_user,
      });
    }
  }, [isAuthenticated, userInfo, posthog]);

  return null; // This component doesn't render anything
};

export default PostHogUserTracker;
